export class InputNumber {
    decimals?:number;
    formatCero?:boolean;
    btnEnable?:boolean;
    bold?:boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    submitted?: boolean;
    validatorAlert?: boolean;
}

